import { useState, createContext, useEffect, ReactNode } from 'react';
import { AppVersionModal } from '@web3/base-components';
import { useFm, useToast } from '@web3/base-hooks';
import { versionIsSupportByApp, isInWeb3Mini } from '@web3/base-utils';

export const AppVersionContext = createContext<{
  openAppVersionModal: () => Promise<boolean>;
}>({
  openAppVersionModal: () => Promise.resolve(true),
});

AppVersionContext.displayName = 'AppVersionContext';
interface Props {
  children: ReactNode;
}

export const AppVersionProvider = (props: Props) => {
  const { children } = props;
  const [showVersionModal, setShowVersionModal] = useState(false);
  const fm = useFm();
  const { toastWarn } = useToast();

  const openAppVersionModal = async () => {
    if (isInWeb3Mini()) {
      toastWarn(fm('visitWsotDexWaveTip'));
      return;
    }

    const isSupport = await versionIsSupportByApp('4.53.0');

    if (!isSupport) {
      setShowVersionModal(true);
      return false;
    }

    return true;
  };

  useEffect(() => {
    if (isInWeb3Mini()) {
      toastWarn(fm('visitWsotDexWaveTip'));
    }
  }, []);

  return (
    <AppVersionContext.Provider
      value={{
        openAppVersionModal,
      }}
    >
      {children}
      <AppVersionModal
        show={showVersionModal}
        onClose={() => {
          setShowVersionModal(false);
        }}
        text={fm('appVersionUpdateReminder', {
          version: '4.53.0',
          time: '2024-11-18',
        })}
        buttonText={fm('ok')}
      />
    </AppVersionContext.Provider>
  );
};
